import WithFetchContract from "./WithFetchContract/index";
import { setDisplayName, compose, withProps } from "recompose";
import TrackSection from "../components/TrackSection";
import { withRouter } from "react-router-dom";

export default compose(
  setDisplayName("TrackShow"),
  WithFetchContract,
  withRouter,
  withProps(({ currentContract }) => ({ contract: currentContract }))
)(TrackSection);
